import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=dea1871c&"
import script from "./InputSearch.vue?vue&type=script&lang=js&"
export * from "./InputSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports